import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AnalyticsModule } from '../analytics/analytics.module';
import { DocumentsModule } from '../documents/documents.module';
import { DocumentsService } from '../documents/services/documents.service';
import { EcapsCoreModule } from '../ecaps-core/ecaps-core.module';
import { SelectionsModule } from '../selections/selections.module';
import { ChartingModule } from './charting/charting.module';
import { AmcaSealComponent } from './components/amca-seal/amca-seal.component';
import { LouverCertificationDialog } from './controllers/louver-certification-dialog.controller';
import { ProductInfoDialog } from './controllers/product-info-dialog.controller';
import { Products } from './controllers/products.controller';
import { SizeChartDialog } from './controllers/size-chart-dialog.controller';
import { LouverCertificationDialogComponent } from './dialogs/louver-certification-dialog/louver-certification-dialog.component';
import { ProductInfoDialogComponent } from './dialogs/product-info-dialog/product-info-dialog.component';
import { SizeChartDialogComponent } from './dialogs/size-chart-dialog/size-chart-dialog.component';
import { ValidSizeWarningDialogComponent } from './dialogs/valid-size-warning-dialog/valid-size-warning-dialog.component';
import { CatalogService } from './services/catalog.service';
import { DescriptionService } from './services/description.service';
import { DrawingService } from './services/drawing.service';
import { ProductsService } from './services/products.service';

@NgModule({
  imports: [
    CommonModule,
    ChartingModule,
    EcapsCoreModule,
    ReactiveFormsModule,
    MatDialogModule,
    SelectionsModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatToolbarModule,
    MatTabsModule,
    MatTableModule,
    MatCardModule,
    DocumentsModule,
    MatRippleModule,
    MatTooltipModule,
    AnalyticsModule,
  ],
  declarations: [
    ProductInfoDialogComponent,
    SizeChartDialogComponent,
    ValidSizeWarningDialogComponent,
    LouverCertificationDialogComponent,
    AmcaSealComponent,
  ],
  providers: [
    CatalogService,
    DescriptionService,
    DrawingService,
    ProductsService,
    DocumentsService,
    Products,
    SizeChartDialog,
    ProductInfoDialog,
    LouverCertificationDialog,
  ],
})
export class ProductsModule {}
